(function () {
    'use strict';

    var imageSliders = document.querySelectorAll('.mol-image-slider');

    for (var i = 0; i < imageSliders.length; i++) {
        var swiperContainer =
            imageSliders[i].querySelector('.swiper');

        const nextEl = imageSliders[i].querySelector('.slider-navigation-next');
        const prevEl = imageSliders[i].querySelector('.slider-navigation-prev');
        const paginationEl =
            imageSliders[i].querySelector('.swiper-pagination');
        const classExists =
            document.getElementsByClassName('tpl-content-page').length > 0;

        new Swiper(swiperContainer, {
            spaceBetween: 16,
            slidesPerView: 1.2,
            watchOverflow: true,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            },
            pagination: {
                el: paginationEl,
                clickable: true,
                type: 'bullets',
            },
            breakpoints: {
                1022: {
                    slidesPerView: classExists ? 2.2 : 0.8,
                },
                1025: {
                    slidesPerView: classExists ? 2.2 : 1.2,
                },
            },
        });
    }
})();
